import React, { Component, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
const UserComponent = lazy(() => import('./routes/User'));
const AdminComponent = lazy(() => import('./routes/Admin'));

const WaitingComponent = (Component) => {
  return (props) => (
    <Suspense fallback={<div>Loading...</div>}>
      <Component {...props} />
    </Suspense>
  );
};

class AppContent extends Component {
  render() {
    const isAdmin = history.location.pathname.indexOf('changeControl');

    return isAdmin > 0 ? (
      <div className="wrapper" style={{ height: 'auto' }}>
        <BrowserRouter basename={process.env.NODE_ENV === 'production' ? '/tty_compare' : ''}>
          <Switch>
            <Route path="/changeControl" component={WaitingComponent(AdminComponent)} />
          </Switch>
        </BrowserRouter>
      </div>
    ) : (
      <div className="wrapper" style={{ height: 'auto' }}>
        <BrowserRouter basename={process.env.NODE_ENV === 'production' ? '/tty_compare' : ''}>
          <Switch>
            <Route path="/" component={WaitingComponent(UserComponent)} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withRouter(AppContent);
